<template>
  <span v-if="settings" class="answer-model-info" role="group" aria-label="답변 생성 설정">
    <span class="answer-model-info__item answer-model-info__model" :title="settings.model"
      :aria-label="`모델 ${settings.model}`">
      <v-icon size="14" aria-hidden="true">mdi-chip</v-icon>
      <span class="answer-model-info__model-name">{{ settings.model }}</span>
    </span>
    <span v-if="settings.temperature !== null" class="answer-model-info__item answer-model-info__temperature" title="Temperature"
      :aria-label="`Temperature ${temperature}`">
      <v-icon size="14" aria-hidden="true">mdi-thermometer</v-icon>
      {{ temperature }}
    </span>
    <span v-if="settings.isThink" class="answer-model-info__item answer-model-info__thinking" title="깊은 사고 켜짐">
      <span class="answer-model-info__thinking-icon" role="img" aria-label="깊은 사고 켜짐">
        <v-icon size="14" aria-hidden="true">mdi-brain</v-icon>
      </span>
      <span v-if="settings.reasoningEffort" :aria-label="`Reasoning effort ${settings.reasoningEffort}`">
        {{ settings.reasoningEffort }}
      </span>
    </span>
  </span>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import { parseAnswerModelSettings } from '@/utils/answerModelSettings';

const props = defineProps({ llm: { type: String, default: null } });
const settings = computed(() => parseAnswerModelSettings(props.llm));
const temperature = computed(() => settings.value?.temperature != null ? Number(settings.value.temperature.toFixed(6)) : null);
</script>

<style scoped>
.answer-model-info {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  min-width: 0;
  min-height: 24px;
  padding: 2px 8px;
  border: 1px solid #ededed;
  border-radius: 6px;
  background: #fafafa;
  color: #6b7280;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.4;
}

.answer-model-info__item {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0 7px;
  white-space: nowrap;
}

.answer-model-info__item + .answer-model-info__item {
  border-left: 1px solid #e5e7eb;
}

.answer-model-info__item:first-child {
  padding-left: 0;
}

.answer-model-info__item:last-child {
  padding-right: 0;
}

.answer-model-info__model {
  min-width: 0;
  max-width: 340px;
}

.answer-model-info__model-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.answer-model-info__temperature {
  font-variant-numeric: tabular-nums;
}

.answer-model-info__thinking-icon {
  display: inline-flex;
  align-items: center;
}

@media (max-width: 600px) {
  .answer-model-info__model {
    max-width: 160px;
  }
}
</style>
